/**
 * Action types for Unified Action Protocol
 * These constants define all available actions that can be sent via ACTION_REQUEST
 */
export const ACTIONS = {
  // Account management actions
  GET_ACCOUNTS: 'get-accounts',
  SWITCH_ACCOUNT: 'switch-account',
  ADD_ACCOUNT: 'add-account',
  REMOVE_ACCOUNT: 'remove-account',

  // Authentication actions
  LOGOUT_ACCOUNT: 'logout-account',
  LOGOUT_ALL: 'logout-all',

  // Profile management actions
  MANAGE_ACCOUNT: 'manage-account',
  UPDATE_AVATAR: 'update-avatar',

  // Session management actions
  SET_SESSION: 'set-session',  // Set session data from host (external login)
} as const;

/**
 * Action type - union of all possible action values
 */
export type Action = typeof ACTIONS[keyof typeof ACTIONS];
